import { Component, HostListener, OnInit, Renderer2, OnDestroy, NgZone } from '@angular/core';
import { RouterOutlet, NavigationEnd } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SpinnerComponent } from "./modules/admin/components/spinner/spinner.component";
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { TimeoutService } from './services/timeout.service';
import { UserActivityService } from './services/user-activity.service';
import { MsalModule } from '@azure/msal-angular';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TranslateModule, SpinnerComponent,MsalModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
  
export class AppComponent implements OnInit, OnDestroy{
  title = 'JapanDirectTimeApp';
  private timeoutSub!: Subscription;
  private keydownListener?: () => void;

  constructor(
    private timeoutService: TimeoutService,
    private activityService: UserActivityService,
    private router: Router,
    private auth: AuthService,
    private renderer: Renderer2,
    private ngZone: NgZone
  ) {}
  // constructor(private translate: TranslateService) {
  //   translate.addLangs(['en', 'fr']);
  //   translate.setDefaultLang('en');
  //   translate.use(translate.getBrowserLang()?.match(/en|jp/) ? translate.getBrowserLang()! : 'en');
  // }

  // switchLanguage(lang: string) {
  //   this.translate.use(lang);
  // }

  ngOnInit() {
    // const storedToken = this.auth.getToken() ?? null;
    var siteLang = this.auth.getLang();
    if (siteLang == 'en') {
      this.renderer.removeClass(document.body, 'body-jp-class');      
    } else {
      this.renderer.addClass(document.body, 'body-jp-class');
    }
     

    // Subscribe to timeout event
    
    // keydown リスナを Angular Zone 外で登録して Change Detection を起動させない
    // （日本語 IME 変換中に ngModel が DOM を書き展す問題を防ぐ）
    this.ngZone.runOutsideAngular(() => {
      const handler = () => this.activityService.notifyActivity();
      document.addEventListener('keydown', handler);
      this.keydownListener = () => document.removeEventListener('keydown', handler);
    });

    // タイムアウト監視：ログイン状態に関わらず常にサブスクライブ
    this.timeoutSub = this.activityService.timeout$.subscribe(() => {
      this.ngZone.run(() => this.onUserTimeout());
    });

    // ナビゲーション完了時にログイン中ならタイマーを（再）起動
    // ログインページから遷移した直後も確実にタイマーが開始される
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe(() => {
      if (this.auth.isLoggedIn()) {
        this.activityService.notifyActivity();
      }
    });

    // 起動時点でログイン済みならタイマーを即開始
    if (this.auth.isLoggedIn()) {
      this.activityService.notifyActivity();
    }
  }

  ngOnDestroy() {
    this.timeoutSub?.unsubscribe();
    this.keydownListener?.();
  }

  @HostListener('document:mousemove')
  @HostListener('document:click')
  @HostListener('document:scroll')
  refreshUserActivity() {
    if (!this.auth.isLoggedIn()) return;
    this.activityService.notifyActivity();
  }

  private onUserTimeout() {
    if (!this.auth.isLoggedIn()) return;
    console.log('User inactive for 15 minutes');
    this.auth.isTimingOut = true;
    this.auth.logout();
  }
}
